import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import Icon from '../widgets/Icon/index';
import './styles.scss';

const ContentModalPlaylistPreviewLink = ({ playlist, ticker, icon, label }) => {
  if (!playlist) {
    return (
      <Fragment>
        <span style={{ marginLeft: '7px', alignSelf: 'center', marginTop: '10px' }} className="secondary disabled preview-link hide-for-desktop">
          {icon && <Icon title="Preview" name="eye" color="grey" size="1.3rem" margin="8px 5px 2px 0px" />}

        </span>
        <span style={{ marginLeft: '5px', alignSelf: 'center', marginTop: '8px', padding: '11px' }} className=" button secondary disabled preview-link hide-for-mobile">
          {label}
        </span>
      </Fragment>
    );
  }

  const previewLink = `/preview/${playlist}/${ticker ? `${ticker}/` : ''}`;

  return (
    <Fragment>

      <Link style={{ marginLeft: '7px', alignSelf: 'center', marginTop: '10px' }} to={previewLink} className={classnames({ ' secondary': icon }, 'preview-link hide-for-desktop')}>
        {icon && <Icon title="Preview" name="eye" size="1.3rem" margin="8px 5px 2px 0px" />}

      </Link>

      <Link style={{ marginLeft: '5px', alignSelf: 'center', marginTop: '8px', padding: '11px' }} to={previewLink} className={classnames({ 'button secondary': icon }, 'button preview-link secondary hide-for-mobile')}>
        {label}

      </Link>

    </Fragment>
  );
};

ContentModalPlaylistPreviewLink.propTypes = {
  playlist: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  ticker: PropTypes.number,
  icon: PropTypes.bool,
  label: PropTypes.string,
};

ContentModalPlaylistPreviewLink.defaultProps = {
  ticker: null,
  icon: false,
  label: null,
};

export default ContentModalPlaylistPreviewLink;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/ContentModalPlaylistPreviewLink /index.js